import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../redux/index";
import PageInput from './PageInputCopy.jsx';
import PageDropdown from './PageDropdownWithIdObjCopy.jsx';
import ApiRequestButton from './ApiRequestButton';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const EditConsortiumModal = () => {
    // get page context from parent
    const {
        editConsortiumModal,
        setEditConsortiumModal,
        portfolioObj,
        portfolioList,
        snackbarAlert,
        getConsortiumData,
        consortiumPayoutTypeObj,
        consortiumPayoutTypeList
    } = useContext(PageContext);
    // get HTTP context from parent
    const {
        PUT,
    } = useContext(HttpContext);
    // get global redux state 
    const consortiumId = useSelector((state) => state.consortiumId);
    const dispatch = useDispatch();
    const { setConsortiumId } = bindActionCreators(actionCreators, dispatch);
    // set state for consortium id 
    const [editConsortiumId, setEditConsortiumId] = useState(consortiumId);
    const [editPortfolioObj, setEditPortfolioObj] = useState(portfolioObj);
    const [editConsortiumPayoutTypeObj, setEditConsortiumPayoutTypeObj] = useState(consortiumPayoutTypeObj);

    // event handler for submit button click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            // validate consortium dropdown 
            if (!portfolioList.includes(editPortfolioObj)) {
                snackbarAlert(true, 'Invalid portfolio selection.', 'error');
                reject();
                return;
            }
            // use PUT function to make query 
            PUT('/consortium/editConsortium', {
                consortiumid: consortiumId,
                incentiveid: editPortfolioObj['id'],
                payouttypeid: editConsortiumPayoutTypeObj['id']
            }).then(res => {
                console.log(res);
                // show snackbar on success
                snackbarAlert(true, 'Successfully updated Consortium ID.', 'success');
                // hide modal on success 
                setEditConsortiumModal(editConsortiumModal => editConsortiumModal = false);
                // refresh data
                return getConsortiumData();
            }).then(res => {
                console.log(res);
                // resolve on success 
                resolve(res);
            }).catch(err => {
                // show snackbar on error
                snackbarAlert(true, 'Error updating Consortium ID.', 'error');
                // reject on error
                reject(err);
            });
        });
    }

    // useEffect to run on consortiumId change
    useEffect(() => {
        setEditConsortiumId(editConsortiumId => editConsortiumId = consortiumId);
    }, [editConsortiumModal, consortiumId]);

    // useEffect to run on portfolioObj change
    useEffect(() => {
        let temp;
        for (let i = 0; i < portfolioList.length; i++) {
            if (portfolioList[i]['id'] == portfolioObj['id']) {
                temp = portfolioList[i];
            }
        }
        setEditPortfolioObj(editPortfolioObj => editPortfolioObj = temp);
    }, [editConsortiumModal, portfolioObj, portfolioList]);

    // useEffect to run on consortiumPayoutType change
    useEffect(() => {
        let temp = consortiumPayoutTypeObj;
        for (let i = 0; i < consortiumPayoutTypeList.length; i++) {
            if (consortiumPayoutTypeList[i]['id'] == consortiumPayoutTypeObj['id']) {
                temp = consortiumPayoutTypeList[i];
            }
        }
        setEditConsortiumPayoutTypeObj(editConsortiumPayoutTypeObj => editConsortiumPayoutTypeObj = temp);
    }, [editConsortiumModal, consortiumPayoutTypeObj, consortiumPayoutTypeList]);

    return (
        <>
            <CCOffcanvas
                title={`Edit info: ${consortiumId}`}
                show={editConsortiumModal}
                onCanvasClose={() => setEditConsortiumModal(editConsortiumModal => editConsortiumModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3"
                offCanvasClassName="offcanvas-parent-card-30"
            >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column flex-grow-1 overflow-scroll">

                        <div className="d-flex align-items-center justify-content-start">
                            <PageInput tag='Consortium ID' value={editConsortiumId} setValue={setEditConsortiumId} disableEdit={true} topAlignTypography={true} width={'100%'}/>
                        </div>
                        <div className="d-flex align-items-center justify-content-start mt-3">
                            <PageDropdown tag='Portfolio' obj={editPortfolioObj} setObj={setEditPortfolioObj} list={portfolioList} topAlignTypography={true} width={'100%'} />
                        </div>
                        <div className="d-flex align-items-center justify-content-start mt-3">
                            <PageDropdown tag='Payout Type' obj={editConsortiumPayoutTypeObj} setObj={setEditConsortiumPayoutTypeObj} list={consortiumPayoutTypeList} topAlignTypography={true} width={'100%'} />
                        </div>
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={"Cancel"}
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                            onButtonClick={() => setEditConsortiumModal(editConsortiumModal => editConsortiumModal = false)}
                        />
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>

        </>
    );
}

export default EditConsortiumModal; 